module.exports = __webpack_public_path__ + "static/media/cs.6ab01634.png";